import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Input, Steps, Modal, message} from 'antd';
const Step = Steps.Step;
import {API_CODE_SUCCESS, API_CODE_RECORD_EXISTS} from '../../config';
import sendMailKey from '../../action/login/sendMailKey';
import validMailKey from '../../action/login/validMailKey';
import editPassword from '../../action/settings/editPassword';
import ValidForm from './validForm';
import RestForm from './resetForm';

const steps = [
  {
    title: '验证身份'
  }, {
    title: '重置密码'
  }
];
const countInit = 60;
let validDate = {
  code: '',
  mail: ''
}

class ForgetPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      codeSend: false,
      count: countInit, // 倒计时时间
      isCountDown: false, // 是否正在倒计时
      isReSet:'',
      checkForm: false // 邮箱和验证码格式正确时，为真。暂时未用上
    }
  }
  componentWillReceiveProps (nextProps) {
    if ('visible' in nextProps && this.props.visible !== nextProps.visible && nextProps.visible) {
      this.setState({current: 0})
    }
  }
  /**
   * 验证身份
   */
  // 请求邮箱验证码
  handleSend = () => {
    const form = this.sendForm;
    form.validateFields((err, values) => {
      const {mail,captcha} = values;
      if (err) {
        return;
      }

      this.props.sendMailKey({mail,imgCode:captcha})
        .then(({retCode, retMsg}) => {
          if (retCode === API_CODE_SUCCESS) {
            message.success('发送成功', 1);
            this.setState({codeSend: true, isCountDown: true});
            this.timer = setInterval(() => {
              let count = this.state.count;
              count -= 1;
              if (count < 1) {
                this.setState({isCountDown: false});
                count = countInit;
                clearInterval(this.timer);
              }
              this.setState({count: count});
            }, 1000);
          } else {
            this.setState({isReSet: Math.floor(Math.random() * (999 - 1) + 1)})
          }
        })
    })
  }

  // 验证邮箱验证码
  handleValid = () => {
    const form = this.sendForm;
    form.validateFields((err, values) => {
      const {mail, code} = values;
      if (err) {
        return;
      }
      this.props.validMailKey({mail, code})
        .then(({retCode, retMsg}) => {
          if (retCode === API_CODE_SUCCESS) {
            validDate = {
              mail,
              code
            };
            this.next();
          }
        })
    })
  }

  // 检查邮箱已填写，验证码格式正确之后，验证按钮可用。暂时未用
  checkCode = (e) => {
    const form = this.props.form;
    const {value} = e.target;
  }
  next = () => {
    const current = this.state.current + 1;
    this.setState({current});
  }

  saveValidFormRef = (form) => {
    this.sendForm = form;
    // 临时进入下一步 this.next();
  }
  saveRestFormRef = (form) => {
    this.restForm = form;
  }

  // 重置密码请求
  handleRest = () => {
    const form = this.restForm;
    form.validateFields((err, values) => {
      const {password} = values;
      const {mail, code} = validDate;
      if (err) {
        return;
      }
      this.props.editPassword({password, mail, code})
        .then(({retCode, retMsg}) => {
          if (retCode === API_CODE_SUCCESS) {
            message.success('修改成功', 1);
            this.setState({visible: false});
            form.resetFields();
            this.props.onCancel();
          }
        })
    });
  }
  render() {
    const {current, codeSend, count, isCountDown, isReSet} = this.state;
    const {visible, onCancel} = this.props;
    return (
      <Modal
        maskClosable={false}
        visible={visible}
        title="找回密码"
        onCancel={onCancel}
        footer={null}>
        <div
          style={{
          width: 300,
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: 20,
          marginBottom: 20
        }}>
          <Steps
            current={current}
            size="small"
            style={{
            marginBottom: 10
          }}>
            {steps.map(item => <Step key={item.title} title={item.title}/>)}
          </Steps>
          <div className="steps-content">
            {this.state.current === 0
              ? <ValidForm
                  ref={this.saveValidFormRef}
                  onSend={this.handleSend}
                  isCodeSend={codeSend}
                  isCountDown={isCountDown}
                  count={count}
                  isReSet={isReSet}/>
              : <RestForm ref={this.saveRestFormRef}/>}
          </div>
          <div
            className="steps-action"
            style={{
            textAlign: 'right'
          }}>
            {this.state.current === 0
              ? <Button type="primary" onClick={this.handleValid} disabled={!codeSend}>验证</Button>
              : <Button type="primary" onClick={this.handleRest}>确认重置</Button>}
          </div>
        </div>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return state;
}
const mapDispatchProps = (dispatch) => {
  return {
    sendMailKey: (params) => dispatch(sendMailKey(params)),
    validMailKey: (params) => dispatch(validMailKey(params)),
    editPassword: (params) => dispatch(editPassword(params))
  }
}

export default connect(mapStateToProps, mapDispatchProps)(ForgetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/login/forgetPasswordForm.js